export const EMPTY_PURGE_USER_DATA_REQUEST = {
  email: '',
};
